var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45 15.28L8.59998 14.42M12.3945 9.7H12.4035M8 21H14C19 21 21 19 21 14V8C21 3 19 1 14 1H8C3 1 1 3 1 8V14C1 19 3 21 8 21ZM15.28 12.61C14.15 13.74 12.53 14.09 11.1 13.64L8.51001 16.22C8.33001 16.41 7.96001 16.53 7.69001 16.49L6.49001 16.33C6.09001 16.28 5.73001 15.9 5.67001 15.51L5.51001 14.31C5.47001 14.05 5.60001 13.68 5.78001 13.49L8.36001 10.91C7.92001 9.48 8.26001 7.86001 9.39 6.73001C11.01 5.11001 13.65 5.11001 15.28 6.73001C16.9 8.34001 16.9 10.98 15.28 12.61Z",
    stroke: "#9197B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.de2424e3ab7da69a4afe7f60956a0eb8.svg";
export { ForwardRef as ReactComponent };